module.exports = __webpack_public_path__ + "media/7.24562fdc.mp3";